import {Route, Routes} from "react-router-dom";
import ShiftList from "./list/List";
import CreateShift from "./create/Create";

const ShiftRouter = props => {
    return (
        <Routes>
            <Route path="/">
                <Route index element={<ShiftList/>}/>

                <Route path="add" element={<CreateShift />}/>
                <Route path="update/:id" element={<CreateShift />}/>

            </Route>

        </Routes>
    );
};

ShiftRouter.propTypes = {};

export default ShiftRouter;